// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"85963fb7","171":"18257f23","480":"d18f0c55"}[chunkId] + ".chunk.js";
};